module.exports = __webpack_public_path__ + "img/5.736a3ffd.png";